<template>
  <div class="clearfix">
      <a-upload
        :customRequest="customRequest"
        list-type="picture-card"
        :file-list="fileList"
        :remove="removeFile"
        :before-upload="beforeUpload"
        :disabled="disableBool"
      >   
             <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
      </a-upload>
  </div>
</template>

<script>
export default {
   data(){
     return{
        loading:false,
     }
   },
   props:{
      fileList:{
          type:Array
      },
      disableBool:{
          type:Boolean,
          default:false
      }
   },
   methods:{
      customRequest(info){
          let formdata=new FormData();
          formdata.append("file",info.file);
          this.loading = true;
          this.$https.post('/file/upload',formdata).then(res=>{
             this.loading = false;
             if(res.code == 200){
                  let obj = {
                      uid: info.file.uid,
                      name: res.data.name,
                      status: 'done',
                      url:res.data.url,
                  }
                  this.fileList.push(obj);
                  this.$emit('getFile',this.fileList)
             }
          }).catch(error=>{
            this.loading = false;
             this.$error({content:'上传失败'});
          })
      },
      removeFile(file){
           let arr = [];
           this.fileList.forEach(item=>{
              if(item.url != file.url){
                  arr.push(item)
              }
           })
           this.$emit('changeFile',arr)
      },
      handleChange(info){
        console.log(info)
          let obj = {};
              obj.uid = info.file.uid;
              obj.name = info.file.name;
              obj.status = info.status;
              // obj.url = info.
      },

      beforeUpload(file) {
        const isJpgOrPng =
          file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
        if (!isJpgOrPng) {
          this.$message.error('请上传图片格式')
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$message.error('图片大小需小于 2MB!')
        }
        return isJpgOrPng && isLt2M;
      },
   }
}
</script>

<style>

</style>